import { render, staticRenderFns } from "./MultiBanner.vue?vue&type=template&id=1628f2d2"
import script from "./MultiBanner.vue?vue&type=script&lang=js"
export * from "./MultiBanner.vue?vue&type=script&lang=js"
import style0 from "./MultiBanner.vue?vue&type=style&index=0&id=1628f2d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports